module.exports = __webpack_public_path__ + "img/title-1.8ca4e328.png";